import Vue from 'vue';
import { getSession, removeStorage } from '../../utils/storage';
import request from '../../utils/request';
import detailInfo from '../../components/insurance/detail-info.vue';
export default Vue.extend({
    name: 'login',
    components: {
        detailInfo: detailInfo,
    },
    created: function () {
        var _a = getSession('policyMation'), selectPolicy = _a.selectPolicy, selectAmout = _a.selectAmout;
        this.policyNum = selectPolicy.length;
        this.selectPolicy = selectPolicy;
        this.selectAmout = selectAmout;
    },
    computed: {
        disabled: function () {
            return !this.isAgree;
        },
    },
    data: function () {
        return {
            inforQuery: '',
            isShowRepeatPolicy: false,
            selectPolicy: [],
            repeatPolicy: [],
            selectAmout: 0,
            policyNum: 0,
            query: {},
            info: [],
            operation: false,
            activeName: 'first',
            type: '',
            polictData: {},
            active: 0,
            isAgree: true,
        };
    },
    beforeRouteLeave: function (to, from, next) {
        // 离开页面，清除session里的保单信息
        removeStorage('policyMation', sessionStorage);
        next();
    },
    methods: {
        applyLoan: function () {
            var _this = this;
            var params = {
                policies: this.selectPolicy,
            };
            // 提交申请逻辑
            request({
                method: 'post',
                url: '/proxy/api/application/submit',
                data: params,
            }).then(function (res) {
                if (!res)
                    return;
                if (res && !res.errorCode) {
                    var data = res.data;
                    var len = data.length;
                    if (len > 0) {
                        _this.repeatPolicy = data;
                        return (_this.isShowRepeatPolicy = true);
                    }
                    _this.$router.push({
                        path: '/console/insurance/apply-loan-success',
                    });
                }
            });
        },
        toApplyLoan: function () {
            // 返回贷款申请页面
            var repeatPolicy = this.repeatPolicy;
            this.isShowRepeatPolicy = false;
            this.$router.push({
                name: 'applyLoan',
                params: { repeatPolicy: repeatPolicy },
            });
        },
        toLoanContract: function () {
            var href = this.$router.resolve({
                name: 'loanAgreement',
                query: { m: this.selectAmout },
            }).href;
            window.open(href, '_blank');
        },
        toLoanRepayment: function () {
            var href = this.$router.resolve({
                name: 'repaymentAgreement',
            }).href;
            window.open(href, '_blank');
        },
    },
});
